import Vue from 'vue';

export default {
  async getByClient(clientId, filter) {
    return (await Vue.http.post(`/api/messages/byclient/${clientId}`, filter)).data;
  },
  async send(message) {
    return (await Vue.http.post('/api/messages/send', message)).data;
  }
}



// WEBPACK FOOTER //
// ./src/services/message.service.js